export const systemLabelsTxt = {
  SCHEDULED: {
    LABEL: "Scheduled",
    TOOLTIP:
      "A scheduled report will send an email or a Slack notification with a copy of your Cloud Analytics report to yourself or other colleagues.",
  },
  CACHED: {
    LABEL: "Cached",
    TOOLTIP:
      "This is a previously cached version of this report. You can re-run this report after making changes to it.",
  },
};
